import React from "react";

export function TryOnIcon({ size = 18, className = "" }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      aria-hidden="true"
    >
      <g stroke="currentColor" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="16" cy="17" r="5" />
        <path d="M6.5 33v-2.5A7.5 7.5 0 0 1 14 23h4.8a7.5 7.5 0 0 1 7.5 7.5V33" />
      </g>
      <path
        d="M32 8c.8 4.9 3.1 7.2 8 8-4.9.8-7.2 3.1-8 8-.8-4.9-3.1-7.2-8-8 4.9-.8 7.2-3.1 8-8Z"
        stroke="var(--adf-champagne)"
        strokeWidth="3"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function TryOnBadge({
  as,
  variant = "full",
  label,
  disabled = false,
  className = "",
  children,
  ...props
}) {
  const Tag = as || (props.onClick ? "button" : "span");
  const text = children || label || "AI ilə yoxla";
  const isIconOnly = variant === "icon";

  return (
    <Tag
      {...props}
      type={Tag === "button" ? props.type || "button" : undefined}
      disabled={Tag === "button" ? disabled : undefined}
      aria-disabled={disabled || undefined}
      aria-label={isIconOnly ? String(text) : props["aria-label"]}
      className={`adf-tryon-badge adf-tryon-badge--${variant} ${className}`.trim()}
    >
      <TryOnIcon size={variant === "full" ? 19 : 17} />
      {!isIconOnly && <span className="adf-tryon-badge__text">{text}</span>}
    </Tag>
  );
}
